// extracted by mini-css-extract-plugin
export default {"button":"Urd0mA","formButton":"rm7mk0","form":"BCHw0L","error":"z3bSM1","summaryBlock":"IH52vg","title":"r5DWfB"};